import { useTranslation } from 'react-i18next';

import { OpText } from 'new-components/DLS/OpText/OpText';
import avigilonAltaLogo from 'assets/img/avigilon-alta-logo-light.svg';

import './OpPageNotFound.scss';

/**
 * @component Page not Found component will redirect to the 404
 * route if using this component on that route
 * @returns 404 page
 */
export const OpPageNotFound = () => {
  const { t } = useTranslation();

  const error = t('404');
  const heading = t('You seem to have veered off course');
  const subheading = t(
    "The page you are looking for doesn't\nexist or you do not have access.",
  );
  return (
    <div className="op-page-not-found" data-testid="op-page-not-found">
      <OpText size="large" fontWeight="700" className="op-page-not-found__text">
        {error}
      </OpText>
      <OpText fontWeight="500" className="op-page-not-found__heading">
        {heading}
      </OpText>
      <OpText className="op-page-not-found__subheading">{subheading}</OpText>
      <img
        className="op-page-not-found__alta-logo"
        src={avigilonAltaLogo}
        alt="Logo"
      />
    </div>
  );
};
